import { categories } from './preSaveTransformers';

export const discardLayoutInfo = ({ recipe }) => {
  const keysToDiscard = [
    'actionFrame',
    'allReferences',
    'comment',
    'details',
    'isOutput',
    'nodeType',
    'pathDepth',
    'label',
  ];
  categories.forEach((category) => {
    const categoryData = recipe[category[0]];
    categoryData?.[category[1]]?.forEach((cat) => {
      keysToDiscard.forEach((key) => {
        delete cat[key];
      });
    });
  });
  return recipe;
};
